module.exports = __webpack_public_path__ + "media/src/images/companies-2bbb7c5b9c90b389b7c55af424e4cb20.jpg";